import Link from "next/link";
import { caseStudyPages } from "@/constants/case-study-pages";
import Subtitle from "@/components/ui/subtitle";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselPrevious,
  CarouselNext,
} from "@/components/ui/carousel";
import CaseStudyThumbnail from "./case-study-thumbnail";

export default function CaseStudiesCarousel({ whiteCards = false }) {
  return (
    <section aria-labelledby="service-case-studies-heading">
      <Subtitle
        subtitle="Real Results"
        textColor="text-vblue3"
        gradientTextColor="from-vblue2 to-vcyan1"
      />
      <Carousel
        opts={{ align: "start", loop: true }}
        aria-label="Client case studies"
      >
        <div className="mb-10 flex items-center justify-between gap-4">
          <h2
            id="service-case-studies-heading"
            className="text-4xl font-bold !leading-[1.15] tracking-normal text-ups-text md:text-5xl"
          >
            Case studies
          </h2>
          <div className="flex shrink-0 gap-2 sm:gap-3">
            <CarouselPrevious className="static size-11 translate-y-0 md:size-14 [&_svg]:size-6" />
            <CarouselNext className="static size-11 translate-y-0 md:size-14 [&_svg]:size-6" />
          </div>
        </div>
        <CarouselContent className="-ml-6 items-stretch">
          {caseStudyPages.map((study, index) => (
            <CarouselItem
              key={study.slug}
              aria-label={`${index + 1} of ${caseStudyPages.length}`}
              className="basis-full pl-6 md:basis-1/2 xl:basis-1/3"
            >
              <article className="h-full">
                <Link
                  href={study.path}
                  aria-label={study.title}
                  className="group flex h-full flex-col rounded-3xl focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-blue-600"
                >
                  <CaseStudyThumbnail study={study} whiteBackground={whiteCards} />
                  <h3 className="mt-6 text-xl font-bold leading-snug text-black group-hover:text-vblue3">
                    {study.title}
                  </h3>
                </Link>
              </article>
            </CarouselItem>
          ))}
        </CarouselContent>
      </Carousel>

    </section>
  );
}
